import * as THREE from 'three'

export default class Hotspots {
    constructor() {
        this.hotspots = [
            //Zonas sociales   
            {
                position: new THREE.Vector3(-0.7, 0.84, -2.4),
                element: document.querySelector('.hotspot-0'),
                label: 'Terraza',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/terraza.jpg'
            },
            {
                position: new THREE.Vector3(-1.02, 0.68, -1.7),
                element: document.querySelector('.hotspot-1'),
                label: 'Salón de juegos',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/social-kitchen.jpg'
            },
            {
                position: new THREE.Vector3(-1.02, 0.45, -1.7),
                element: document.querySelector('.hotspot-2'),
                label: 'Gimnasio',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/lobby.jpg'
            },
            {
                position: new THREE.Vector3(-0.06, 0.68, -2.41),
                element: document.querySelector('.hotspot-3'),
                label: 'Salón de yoga',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/salon-juegos.jpg'
            },
            {
                position: new THREE.Vector3(-0.06, 0.24, -2.41),
                element: document.querySelector('.hotspot-4'),
                label: 'Lobby',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/salon-social.jpg'
            },
            {
                position: new THREE.Vector3(1.05, 0.24, -2.41),
                element: document.querySelector('.hotspot-5'),
                label: 'Plazoleta',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/piscina.jpg'
            },
            {
                position: new THREE.Vector3(-0.52, 0.24, -1.98),
                element: document.querySelector('.hotspot-6'),
                label: 'Coworking',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/piscina.jpg'
            },
            {
                position: new THREE.Vector3(-0.53, 0.68, -3.07),
                element: document.querySelector('.hotspot-7'),
                label: 'Salón comunal',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/piscina.jpg'
            },
            {
                position: new THREE.Vector3(0.34, 0.32, -1.59),
                element: document.querySelector('.hotspot-8'),
                label: 'Lobby torre',
                img: 'https://chromastudio.co/sole/wp-content/uploads/2022/03/piscina.jpg'
            },
            //Cercanias        
            {
                position: new THREE.Vector3(-1, 0.34, -25),
                element: document.querySelector('.hotspot-9')//Colegio Agustiniano
            },
            {
                position: new THREE.Vector3(15, 0.96, -17),
                element: document.querySelector('.hotspot-10')//Centro Comercial ILARCO
            }
            , {
                position: new THREE.Vector3(-10.0, 0.96, -14.0),
                element: document.querySelector('.hotspot-11')//Fundacion Clinica Shaio
            },
            {
                position: new THREE.Vector3(25, 0.96, -15),
                element: document.querySelector('.hotspot-12')//Colegio Emmanuel D' Alzon
            },
            /*{
                position: new THREE.Vector3(39, 0.96, -16),
                element: document.querySelector('.hotspot-13')
            },*/
            //Colegio Moderno John Dewey
            {
                position: new THREE.Vector3(33, 0.96, -3),
                element: document.querySelector('.hotspot-14')//Parque Puente Largo
            },
            {
                position: new THREE.Vector3(23, 0.96, 11),
                element: document.querySelector('.hotspot-15')//Estación Puente Largo
            },
            {
                position: new THREE.Vector3(9, 0.96, -22.6),
                element: document.querySelector('.hotspot-16')//Estación Av. Suba - Calle 116
            },
            {
                position: new THREE.Vector3(39, 0.34, 39),
                element: document.querySelector('.hotspot-17')//Iserra 100 Centro Comercial
            },

            //Vias
            {
                position: new THREE.Vector3(-1, 0.2, -21),
                element: document.querySelector('.hotspot-18')//Av. Pepe Sierra
            },
            {
                position: new THREE.Vector3(15, 0.2, -3),
                element: document.querySelector('.hotspot-19')//Av. Suba
            }
            , {
                position: new THREE.Vector3(-6.1, 0.2, -2.3),
                element: document.querySelector('.hotspot-20')//Carrera 70
            },
            {
                position: new THREE.Vector3(6, 0.2, 8),
                element: document.querySelector('.hotspot-21')//Carrera 68A
            },
            {
                position: new THREE.Vector3(-1.45, 0.2, 34.1),
                element: document.querySelector('.hotspot-22')//Carrera 68
            }
        ]
    }
}



